import { Button, Input } from '@quadralize/ui'
import { isPlaceholderLocationLabel } from '@quadralize/utils'
import { CheckCircle, DangerCircle, MapPoint } from '@solar-icons/react'
import { useEffect, useState } from 'react'
import { useUserLocation } from '@/hooks/use-user-location'
import { useAppStore } from '@/store/use-app-store'

export function LocationPermissionBanner() {
  const { status, city, error, requestLocation } = useUserLocation()
  const selectedCity = useAppStore((state) => state.selectedCity)
  const setSelectedCity = useAppStore((state) => state.setSelectedCity)

  const [manualLocationInput, setManualLocationInput] = useState(
    isPlaceholderLocationLabel(selectedCity) ? '' : selectedCity,
  )

  useEffect(() => {
    if (status !== 'success') {
      return
    }

    const nextCity = city?.trim() || 'Perto de você'
    if (selectedCity !== nextCity) {
      setSelectedCity(nextCity)
    }
  }, [status, city, selectedCity, setSelectedCity])

  useEffect(() => {
    if (!isPlaceholderLocationLabel(selectedCity)) {
      setManualLocationInput(selectedCity)
    }
  }, [selectedCity])

  function handleUseManualLocation() {
    const normalized = manualLocationInput.trim()
    if (!normalized) {
      return
    }
    setSelectedCity(normalized)
  }

  if (status === 'success') {
    return null
  }

  return (
    <div className="border-b border-border-subtle bg-brand-primary-50 px-4 py-3 md:px-8">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div className="flex min-w-0 items-start gap-2.5">
          {status === 'error' ? (
            <DangerCircle className="mt-0.5 h-4 w-4 shrink-0 text-error" />
          ) : status === 'loading' ? (
            <CheckCircle className="mt-0.5 h-4 w-4 shrink-0 text-primary animate-pulse" />
          ) : (
            <MapPoint className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
          )}

          <div className="min-w-0">
            <p className="text-sm font-semibold text-text-primary">
              Usamos sua localização para mostrar quadras próximas de você.
            </p>
            {status === 'loading' && (
              <p className="text-xs text-text-secondary">Obtendo sua localização...</p>
            )}
            {status === 'error' && error?.message && (
              <p className="text-xs text-error">{error.message}</p>
            )}
          </div>
        </div>

        <div className="flex flex-col gap-2 md:min-w-90 md:items-end">
          {status === 'error' ? (
            <div className="grid w-full gap-2 sm:grid-cols-[1fr_auto]">
              <Input
                value={manualLocationInput}
                onChange={(event) => setManualLocationInput(event.target.value)}
                placeholder="Digite cidade ou CEP"
                className="h-10"
              />
              <Button
                variant="secondary"
                className="h-10 md:h-10"
                onClick={handleUseManualLocation}
              >
                Usar manualmente
              </Button>
            </div>
          ) : (
            <Button
              size="sm"
              className="w-full md:w-auto"
              onClick={() => requestLocation()}
              disabled={status === 'loading'}
            >
              {status === 'loading' ? 'Buscando localização...' : 'Permitir localização'}
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
